<template>
    <div id="attacks-view" class="view">
        <teleport to="#sub-nav">
            <span class="sub-nav-item" :class="{selected: type === 'incoming'}" @click="type='incoming'">
                Incoming
            </span>
            <span> | </span>
            <span class="sub-nav-item" :class="{selected: type === 'outgoing'}" @click="type='outgoing'">
                Outgoing
            </span>
        </teleport>

        <div id="attacks-content">
            <table>
                <thead>
                    <th>{{type === 'incoming' ? 'Attacker' : 'Victim'}}</th>
                    <th>Timestamp</th>
                    <th>Action</th>
                    <th>Stealthed</th>
                    <th>Link</th>
                </thead>
                <tbody>
                    <tr v-for="attack in attacks" :key="'attack' + attack.id">
                        <td v-if="type=== 'incoming'">
                            {{getplayer(attack.data.attacker) ? getplayer(attack.data.attacker).name : 'Anonymous'}}
                            <span class="user-id">[{{attack.data.attacker}}]</span>
                        </td>
                        <td v-else>
                            {{getplayer(attack.data.defender)?getplayer(attack.data.defender).name : 'A Player'}} 
                            <span class="user-id">[{{attack.data.defender}}]</span>
                        </td>
                        <td>{{attack.formatted_date}}</td>
                        <td>{{attack.title}}</td>
                        <td>{{attack.data.anonymous ? 'True' : 'False'}}</td>
                        <td class="log-link" v-html="attack.data.log"></td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'Attacks',
    data() {
        return {
            type: 'incoming', 
        }
    },

    methods: {
    },
    
    mounted() {
        this.$store.dispatch('getLogs');
    },
    
    computed: {
        ...mapGetters([
            'outgoing_attacks',
            'logs',
            'incoming_attacks'
        ]),

        attacks() {
            let key = `${this.type}_attacks`;
            return this[key];
        }   
    },
}
</script>
<style lang="scss">


</style>